import { Child, Guardian } from '.';

export interface IApplication {
	internalApplicationId:string;
	completedByInternalGuardianId: number;
	enteredInLanguageId: number;
	submissionDate: string; // ISO Date format
	academicYearId: number;
	guardians: Guardian[];
	children: Child[];
	crmLeadId: string;
	completedByEmail: string;
}

export class Application implements IApplication {
	internalApplicationId:string;
	completedByInternalGuardianId: number;
	enteredInLanguageId: number;
	submissionDate: string; // ISO Date format
	academicYearId: number;
	guardians: Guardian[];
	children: Child[];
	crmLeadId: string;
	completedByEmail: string;
}
